import jwt from 'jsonwebtoken'
import settings from "../config/settings";

const AuthService = () => {
    let authToken = localStorage.getItem('accessToken')
    //let authSecret = 'f24ae3ef1dd937560b7ab6885b303d5e36c77412d4e8c5e13d65ba6e48f699fe5fec3657f25518be882ba4ba8f93ccb3094a7fc96fcc6aea05de5b3b2dd056c1'
    //let role = localStorage.getItem('role')
    if (authToken) {
        return jwt.verify(authToken, settings.AUTH_SECRET, (err, decoded) => {
            if (err) {
                console.log(err)
                return { authorised: false }
            }
            else {
                return { authorised: true }
            }
        })
    }
    else {
        return { authorised: false }
    }
}

export default AuthService